import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@wfp-root-app/store/store';

import State from '../app/store/state';
import { hasFeatureAccess, ActionCreators as authActionCreators } from '../login/auth';
import { SideMenu } from '../utils/SideMenu';
import { ManagerPermission } from '../permission-profiles/permission';

enum ManagerTabs {
    PasswordAndSecurity = 'Password & Security',
    DetailsAndPreferences = 'Personal Details & Preferences',
    ActivityLogs = 'Activity Logs',
}

const urlPathForTab = {
    [ManagerTabs.PasswordAndSecurity]: 'security',
    [ManagerTabs.DetailsAndPreferences]: 'details',
    [ManagerTabs.ActivityLogs]: 'activity-log',
};

const ManagersMainPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const auth = useSelector((state: State) => state.auth);

    const reloadUserData = () => dispatch(authActionCreators.reloadUserData());

    useEffect(() => {
        reloadUserData();
    }, [dispatch]); // Added dispatch as a dependency

    const activeMenuTab = (): ManagerTabs => {
        const parts = location.pathname.split('/');
        const lastUrlPart = parts.filter((part) => part.length > 0).pop();

        for (const key of Object.keys(urlPathForTab)) {
            if (urlPathForTab[key] === lastUrlPart) {
                return key as ManagerTabs;
            }
        }
        return ManagerTabs.DetailsAndPreferences;
    };

    const renderSidemenu = () => {
        const subtabs = [ManagerTabs.DetailsAndPreferences];

        subtabs.push(ManagerTabs.PasswordAndSecurity);
        if (hasFeatureAccess(auth, ManagerPermission.userActivityView)) {
            subtabs.push(ManagerTabs.ActivityLogs);
        }
        const activeTab = activeMenuTab();

        return (
            <div>
                <SideMenu
                    activeTab={activeTab}
                    onSelectTab={(tab) => {
                        const url = urlPathForTab[tab];
                        navigate(`/personal/${url}`);
                    }}
                    tabs={subtabs}
                />
            </div>
        );
    };

    const renderBreadcrumbs = () => {
        return (
            <div className="row col-sm-12">
                <nav className="wfp-breadcrumbs col-sm-6">
                    <ol className="breadcrumbs--wrapper">
                        <li className="breadcrumbs--item">
                            <Link className="breadcrumbs--link" to="/home">
                                <span>Home</span>
                            </Link>
                        </li>
                        <li className="breadcrumbs--item">
                            <span className="breadcrumbs--last">{`Personal`}</span>
                        </li>
                    </ol>
                </nav>
            </div>
        );
    };

    return (
        <main className={'row'}>
            {renderBreadcrumbs()}
            <div className="col-sm-3">{renderSidemenu()}</div>
            <div className="col-sm-9" style={{ marginBottom: 150 }}>
                {/* Use <Outlet /> to render nested routes in v6 */}
                <Outlet />
            </div>
        </main>
    );
};

export default ManagersMainPage;
